




































import { defineComponent } from "@vue/composition-api";
import { injectStrict } from "@/lib/utils";
import { RubricStoreKey } from "@/store/StoreInjectionKeys";
import PerformanceLevel from "./PerformanceLevel.vue";
import collapse from "./collapse";

export default defineComponent({
  setup(props) {
    const { showCollapse, toggleCollapse } = collapse();
    const rubricStore = injectStrict(RubricStoreKey);

    return {
      rubricStore,
      showCollapse,
      toggleCollapse
    };
  },
  components: {
    PerformanceLevel
  },
  methods: {
    componentNumber(domainIndex: number, componentIndex: number) {
      return `${domainIndex + 1}${String.fromCharCode(componentIndex + 97)}`;
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    domainIndex: {
      type: Number,
      required: true
    },
    componentIndex: {
      type: Number,
      required: true
    },
    componentCount: {
      type: Number,
      required: true
    }
  }
});
